module.exports = __webpack_public_path__ + "img/mail.b38ff560.svg";